export default {
  created() {
    // 判断是否停留在消息中心页面
    this.$store.commit('setIsStayMessagePage', true);
  },
  beforeDestroy() {
    this.$store.commit('setIsStayMessagePage', false);
  },
};
